module.exports = __webpack_public_path__ + "img/82.4.NH3-N.4b587722.png";